window.Products.Clothing.BabyLeggings2years = function() {};

window.Products.Clothing.BabyLeggings2years.inherits(window.Products.Clothing.BabyLeggings);
window.Products.Clothing.BabyLeggings2years.has_3d = true;
window.Products.Clothing.BabyLeggings2years.id = '27-2years';
window.Products.Clothing.BabyLeggings2years.saveId = 27;
window.Products.Clothing.BabyLeggings2years.slug = 'baby-leggings-2years';
window.Products.Clothing.BabyLeggings2years.dpi = 150;